// extracted by mini-css-extract-plugin
module.exports = {"link":"Reference_link__onLzx","externalLink":"Reference_externalLink__Zwcw7","modalLink":"Reference_modalLink__y4gwJ"};